'use client';

import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
import { useRouter } from 'next/navigation';
import { useLocale, useTranslations } from 'next-intl';
import type { FC } from 'react';
import { useUserStore } from '@/entities/User/store/userStoreProvider';
interface GoldStatusActionCardProps {
  className?: string;
}

/**
 * @description Карточка для покупки Gold Status в списке платформ экшенов
 * @example
 * <GoldStatusActionCard />
 *
 * @param {GoldStatusActionCardProps} props
 * @param {string} props.className - Дополнительные CSS классы
 * @returns {JSX.Element}
 */
export const GoldStatusActionCard: FC<GoldStatusActionCardProps> = t0 => {
  const $ = _c(114);
  const {
    className: t1
  } = t0;
  const className = t1 === undefined ? "" : t1;
  const t = useTranslations("actions.goldStatus");
  const router = useRouter();
  const user = useUserStore(_temp);
  const locale = useLocale();
  let t2;
  if ($[0] !== locale || $[1] !== router || $[2] !== user?.id) {
    t2 = () => {
      if (!user?.id) {
        router.push(`/${locale}/auth`);
        return;
      }
      router.push(`/${locale}/settings/my-wallet/buy-gold-status`);
    };
    $[0] = locale;
    $[1] = router;
    $[2] = user?.id;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const handleBuyClick = t2;
  const t3 = `relative flex h-[506px] cursor-pointer flex-col items-center justify-between overflow-hidden rounded-[20px] transition-transform duration-200 hover:scale-[1.02] md:h-[575px] ${className}`;
  let t4;
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="absolute inset-0 rounded-[20px] bg-gradient-to-b from-[#000014] to-[#0000C5]/20" />;
    t5 = <div className="pointer-events-none absolute inset-0 rounded-[24px] border-4 border-[#ffb101]" />;
    $[4] = t4;
    $[5] = t5;
  } else {
    t4 = $[4];
    t5 = $[5];
  }
  let t6;
  if ($[6] !== t) {
    t6 = t("title");
    $[6] = t;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== t6) {
    t7 = <Image src="/images/actions/gold.png" alt={t6} fill={true} className="object-contain" />;
    $[8] = t6;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== t) {
    t8 = t("title");
    $[10] = t;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== t8) {
    t9 = <span className="absolute inset-0 flex items-center justify-center font-['Montserrat'] text-[18px] font-bold uppercase tracking-[1.17px] text-[#876200]">{t8}</span>;
    $[12] = t8;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== t7 || $[15] !== t9) {
    t10 = <div className="absolute left-1/2 top-0 z-10 h-[34px] w-[290px] -translate-x-1/2">{t7}{t9}</div>;
    $[14] = t7;
    $[15] = t9;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== t) {
    t11 = t("header");
    $[17] = t;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== t11) {
    t12 = <h2 className="text-center whitespace-pre-wrap font-['Montserrat'] text-[20px] font-bold uppercase leading-none text-[#f9f9f9] lg:text-[24px]">{t11}</h2>;
    $[19] = t11;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== t) {
    t13 = t("perEach");
    $[21] = t;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  let t14;
  if ($[23] !== t13) {
    t14 = <div className="flex justify-end px-2"><span className="whitespace-pre font-['Inter'] text-[14px] font-medium leading-[1.3] text-[rgba(255,255,255,0.7)]">{t13}</span></div>;
    $[23] = t13;
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  let t15;
  if ($[25] !== t) {
    t15 = t("referralRegistration.title");
    $[25] = t;
    $[26] = t15;
  } else {
    t15 = $[26];
  }
  let t16;
  if ($[27] !== t15) {
    t16 = <div className="font-['Inter'] text-[14px] font-medium leading-[1.15] text-[#e9ecf0]"><p className="mb-0">{t15}</p></div>;
    $[27] = t15;
    $[28] = t16;
  } else {
    t16 = $[28];
  }
  let t17;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <div className="flex h-3 w-3 items-center justify-center"><Image src="/images/actions/coin.png" alt="Coin" width={12} height={12} className="h-full w-full" /></div>;
    $[29] = t17;
  } else {
    t17 = $[29];
  }
  let t18;
  if ($[30] !== t) {
    t18 = t("referralRegistration.coinReward");
    $[30] = t;
    $[31] = t18;
  } else {
    t18 = $[31];
  }
  let t19;
  if ($[32] !== t18) {
    t19 = <div className="flex items-center gap-1 rounded-[1000px] bg-[#e9ecf0] px-2 py-1">{t17}<span className="font-['Inter'] text-[14px] font-semibold leading-[1.3] text-black">{t18}</span></div>;
    $[32] = t18;
    $[33] = t19;
  } else {
    t19 = $[33];
  }
  let t20;
  if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <div className="flex h-3 w-3 items-center justify-center"><Image src="/images/actions/gem.png" alt="Gem" width={12} height={12} className="h-full w-full" /></div>;
    $[34] = t20;
  } else {
    t20 = $[34];
  }
  let t21;
  if ($[35] !== t) {
    t21 = t("referralRegistration.gemReward");
    $[35] = t;
    $[36] = t21;
  } else {
    t21 = $[36];
  }
  let t22;
  if ($[37] !== t21) {
    t22 = <div className="flex items-center gap-1 rounded-[1000px] bg-[#e9ecf0] px-2 py-1">{t20}<span className="font-['Inter'] text-[14px] font-semibold leading-[1.3] text-black">{t21}</span></div>;
    $[37] = t21;
    $[38] = t22;
  } else {
    t22 = $[38];
  }
  let t23;
  if ($[39] !== t19 || $[40] !== t22) {
    t23 = <div className="flex gap-2">{t19}{t22}</div>;
    $[39] = t19;
    $[40] = t22;
    $[41] = t23;
  } else {
    t23 = $[41];
  }
  let t24;
  if ($[42] !== t16 || $[43] !== t23) {
    t24 = <div className="flex items-center justify-between rounded-[14px] bg-[#20202e] p-2 md:p-4">{t16}{t23}</div>;
    $[42] = t16;
    $[43] = t23;
    $[44] = t24;
  } else {
    t24 = $[44];
  }
  let t25;
  if ($[45] !== t) {
    t25 = t("challenge.title");
    $[45] = t;
    $[46] = t25;
  } else {
    t25 = $[46];
  }
  let t26;
  if ($[47] !== t25) {
    t26 = <span className="font-['Inter'] text-[14px] font-medium leading-[1.3] text-[#e9ecf0]">{t25}</span>;
    $[47] = t25;
    $[48] = t26;
  } else {
    t26 = $[48];
  }
  let t27;
  if ($[49] === Symbol.for("react.memo_cache_sentinel")) {
    t27 = <div className="flex h-3 w-3 items-center justify-center"><Image src="/images/actions/gem.png" alt="Gem" width={12} height={12} className="h-full w-full" /></div>;
    $[49] = t27;
  } else {
    t27 = $[49];
  }
  let t28;
  if ($[50] !== t) {
    t28 = t("challenge.reward");
    $[50] = t;
    $[51] = t28;
  } else {
    t28 = $[51];
  }
  let t29;
  if ($[52] !== t28) {
    t29 = <div className="flex items-center gap-1 rounded-[1000px] bg-[#e9ecf0] px-2 py-1">{t27}<span className="font-['Inter'] text-[14px] font-semibold leading-[1.3] text-black">{t28}</span></div>;
    $[52] = t28;
    $[53] = t29;
  } else {
    t29 = $[53];
  }
  let t30;
  if ($[54] !== t26 || $[55] !== t29) {
    t30 = <div className="flex items-center justify-between rounded-[14px] bg-[#20202e] p-2 md:p-4">{t26}{t29}</div>;
    $[54] = t26;
    $[55] = t29;
    $[56] = t30;
  } else {
    t30 = $[56];
  }
  let t31;
  if ($[57] !== t) {
    t31 = t("bidExperience.title");
    $[57] = t;
    $[58] = t31;
  } else {
    t31 = $[58];
  }
  let t32;
  if ($[59] !== t31) {
    t32 = <span className="font-['Inter'] text-[14px] font-medium leading-[1.3] text-[#e9ecf0]">{t31}</span>;
    $[59] = t31;
    $[60] = t32;
  } else {
    t32 = $[60];
  }
  let t33;
  if ($[61] === Symbol.for("react.memo_cache_sentinel")) {
    t33 = <div className="flex h-3 w-3 items-center justify-center"><Image src="/images/actions/gem.png" alt="Gem" width={12} height={12} className="h-full w-full" /></div>;
    $[61] = t33;
  } else {
    t33 = $[61];
  }
  let t34;
  if ($[62] !== t) {
    t34 = t("bidExperience.reward");
    $[62] = t;
    $[63] = t34;
  } else {
    t34 = $[63];
  }
  let t35;
  if ($[64] !== t34) {
    t35 = <div className="flex items-center gap-1 rounded-[1000px] bg-[#e9ecf0] px-2 py-1">{t33}<span className="font-['Inter'] text-[14px] font-semibold leading-[1.3] text-black">{t34}</span></div>;
    $[64] = t34;
    $[65] = t35;
  } else {
    t35 = $[65];
  }
  let t36;
  if ($[66] !== t32 || $[67] !== t35) {
    t36 = <div className="flex items-center justify-between rounded-[14px] bg-[#20202e] p-2 md:p-4">{t32}{t35}</div>;
    $[66] = t32;
    $[67] = t35;
    $[68] = t36;
  } else {
    t36 = $[68];
  }
  let t37;
  if ($[69] !== t) {
    t37 = t("firstTimeEntry.title");
    $[69] = t;
    $[70] = t37;
  } else {
    t37 = $[70];
  }
  let t38;
  if ($[71] !== t37) {
    t38 = <span className="font-['Inter'] text-[14px] font-medium leading-[1.3] text-[#e9ecf0]">{t37}</span>;
    $[71] = t37;
    $[72] = t38;
  } else {
    t38 = $[72];
  }
  let t39;
  if ($[73] === Symbol.for("react.memo_cache_sentinel")) {
    t39 = <div className="flex h-3 w-3 items-center justify-center"><Image src="/images/actions/gem.png" alt="Gem" width={12} height={12} className="h-full w-full" /></div>;
    $[73] = t39;
  } else {
    t39 = $[73];
  }
  let t40;
  if ($[74] !== t) {
    t40 = t("firstTimeEntry.reward");
    $[74] = t;
    $[75] = t40;
  } else {
    t40 = $[75];
  }
  let t41;
  if ($[76] !== t40) {
    t41 = <div className="flex items-center gap-1 rounded-[1000px] bg-[#e9ecf0] px-2 py-1">{t39}<span className="font-['Inter'] text-[14px] font-semibold leading-[1.3] text-black">{t40}</span></div>;
    $[76] = t40;
    $[77] = t41;
  } else {
    t41 = $[77];
  }
  let t42;
  if ($[78] !== t38 || $[79] !== t41) {
    t42 = <div className="flex items-center justify-between rounded-[14px] bg-[#20202e] p-2 md:p-4">{t38}{t41}</div>;
    $[78] = t38;
    $[79] = t41;
    $[80] = t42;
  } else {
    t42 = $[80];
  }
  let t43;
  if ($[81] === Symbol.for("react.memo_cache_sentinel")) {
    t43 = <div className="h-0 min-h-px flex-grow"><div className="h-[1px] bg-[rgba(255,255,255,0.2)]" /></div>;
    $[81] = t43;
  } else {
    t43 = $[81];
  }
  let t44;
  if ($[82] !== t) {
    t44 = t("andMore");
    $[82] = t;
    $[83] = t44;
  } else {
    t44 = $[83];
  }
  let t45;
  if ($[84] !== t44) {
    t45 = <span className="font-['Inter'] text-[14px] font-medium leading-[1.3] text-[rgba(255,255,255,0.7)]">{t44}</span>;
    $[84] = t44;
    $[85] = t45;
  } else {
    t45 = $[85];
  }
  let t46;
  if ($[86] === Symbol.for("react.memo_cache_sentinel")) {
    t46 = <div className="h-0 min-h-px flex-grow"><div className="h-[1px] bg-[rgba(255,255,255,0.2)]" /></div>;
    $[86] = t46;
  } else {
    t46 = $[86];
  }
  let t47;
  if ($[87] !== t45) {
    t47 = <div className="flex items-center gap-[7px]">{t43}{t45}{t46}</div>;
    $[87] = t45;
    $[88] = t47;
  } else {
    t47 = $[88];
  }
  let t48;
  if ($[89] === Symbol.for("react.memo_cache_sentinel")) {
    t48 = {
      background: "linear-gradient(181.03deg, #FFDE01 16.21%, #FFC601 167.89%)"
    };
    $[89] = t48;
  } else {
    t48 = $[89];
  }
  let t49;
  if ($[90] !== t) {
    t49 = t("buyButton");
    $[90] = t;
    $[91] = t49;
  } else {
    t49 = $[91];
  }
  let t50;
  if ($[92] !== t49) {
    t50 = <span className="grow text-left font-['Montserrat'] text-[16px] font-bold uppercase leading-[1.2] text-[#31303d]">{t49}</span>;
    $[92] = t49;
    $[93] = t50;
  } else {
    t50 = $[93];
  }
  let t51;
  if ($[94] === Symbol.for("react.memo_cache_sentinel")) {
    t51 = <g clipPath="url(#clip0_461_23985)"><path fillRule="evenodd" clipRule="evenodd" d="M14 28.375C21.732 28.375 28 22.107 28 14.375C28 6.64301 21.732 0.375 14 0.375C6.26801 0.375 0 6.64301 0 14.375C0 22.107 6.26801 28.375 14 28.375ZM14.0597 10.0576C13.6347 10.4641 13.6347 11.143 14.0597 11.5495L16.0103 13.4155H9.01015C8.45226 13.4155 8 13.8677 8 14.4256C8 14.9835 8.45226 15.4358 9.01015 15.4358H15.9044L14.0596 17.2005C13.6347 17.607 13.6347 18.2859 14.0596 18.6924C14.4588 19.0742 15.0877 19.0742 15.4868 18.6924L19.2446 15.0976C19.6563 14.7038 19.6563 14.0462 19.2446 13.6524L15.4868 10.0576C15.0877 9.67582 14.4588 9.67582 14.0597 10.0576Z" fill="#31303D" /></g>;
    $[94] = t51;
  } else {
    t51 = $[94];
  }
  let t52;
  if ($[95] === Symbol.for("react.memo_cache_sentinel")) {
    t52 = <div className="flex h-7 w-7 items-center justify-center"><svg xmlns="http://www.w3.org/2000/svg" width="28" height="29" viewBox="0 0 28 29" fill="none">{t51}<defs><clipPath id="clip0_461_23985"><rect width="28" height="28" fill="white" transform="translate(0 0.375)" /></clipPath></defs></svg></div>;
    $[95] = t52;
  } else {
    t52 = $[95];
  }
  let t53;
  if ($[96] !== t50) {
    t53 = <button className="flex h-[60px] w-full cursor-pointer items-center justify-center gap-2.5 rounded-[14px] p-4 transition-transform duration-200 hover:scale-[1.02]" style={t48}>{t50}{t52}</button>;
    $[96] = t50;
    $[97] = t53;
  } else {
    t53 = $[97];
  }
  let t54;
  if ($[98] !== t14 || $[99] !== t24 || $[100] !== t30 || $[101] !== t36 || $[102] !== t42 || $[103] !== t47 || $[104] !== t53) {
    t54 = <div className="flex w-full flex-col gap-2">{t14}{t24}{t30}{t36}{t42}{t47}{t53}</div>;
    $[98] = t14;
    $[99] = t24;
    $[100] = t30;
    $[101] = t36;
    $[102] = t42;
    $[103] = t47;
    $[104] = t53;
    $[105] = t54;
  } else {
    t54 = $[105];
  }
  let t55;
  if ($[106] !== t10 || $[107] !== t12 || $[108] !== t54) {
    t55 = <div className="relative flex h-full w-full flex-col items-center justify-end gap-4 p-4 !pt-6">{t10}{t12}{t54}</div>;
    $[106] = t10;
    $[107] = t12;
    $[108] = t54;
    $[109] = t55;
  } else {
    t55 = $[109];
  }
  let t56;
  if ($[110] !== handleBuyClick || $[111] !== t3 || $[112] !== t55) {
    t56 = <div className={t3} onClick={handleBuyClick}>{t4}{t5}{t55}</div>;
    $[110] = handleBuyClick;
    $[111] = t3;
    $[112] = t55;
    $[113] = t56;
  } else {
    t56 = $[113];
  }
  return t56;
};
export type { GoldStatusActionCardProps };
function _temp(store) {
  return store.user;
}